module.exports = __webpack_public_path__ + "img/sy3.a342c2ad.png";